export default __webpack_public_path__ + "static/media/ic-zoom-black.c13a9316.svg";